import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Logger} from '../logging/default-log.service';
import {PendingOrder} from '../classes/pending.order';
import {BaseService} from './base.service';
import {HttpClient} from './http.service';
import {ConfigurationHelper} from '../helper/configuration.helper';

@Injectable()
export class PendingOrderService extends BaseService {
	private http = inject(HttpClient);

	constructor() {
		const logger = inject(Logger);

		super(logger);
	}

	getPendingOrders(): Observable<PendingOrder[]> {
		const url = ConfigurationHelper.getWebshopUrl('/rest/order/pendingorders');
		return this.http.get<PendingOrder[]>(url);
	}

	saveComment(commentValue: string, webuuid: string): Observable<unknown> {
		const url = ConfigurationHelper.getWebshopUrl('/rest/shoppingcart/comment');

		const $xhr = this.http.post(
			url,
			JSON.stringify({
				webUUID: webuuid,
				comment: commentValue
			})
		);

		$xhr.subscribe(
			(result) => {
			},
			(error) => {
				this.logger.error('Error adding comment to shopping cart line', error);
			}
		);

		return $xhr;
	}
}
